export const measurementFields = ['cbm', 'net_weight', 'gross_weight'];
export function calculatePack(pack, level = 'Carton') {
  const batches = pack.batches.map(batch => ({ ...batch }));
  return { ...pack, batches, ...Object.fromEntries(measurementFields.map(field => [field,
    (pack.use_master_measurements && Number(pack[field] || 0) > 0)
      ? Number(pack[field] || 0)
      : level === 'Product' || level === 'Pallet'
        ? batches.reduce((sum, batch) => sum + batch.products.reduce((total, product) => total + Number(product[field] || 0), 0), 0)
        : batches.reduce((sum, batch) => sum + Number(batch[field] || 0), 0)])) };
}
